interface FoodIndicatorProps {
  type: "veg" | "non_veg" | "";
  className?: string;
}

export function UniversalFoodIndicator({
  type,
  className = "",
}: FoodIndicatorProps) {
  if (!type) return null;
  return (
    <div 
      className={`inline-flex ${className}`}
      role="img"
      aria-label={type === "veg" ? "Vegetarian" : "Non-Vegetarian"}
    >
      <div
        className={`lg:w-5 lg:h-5 w-[14px] h-[14px] lg:border-2 border  ${type === "veg" ? "border-green-600" : ""}${type === "non_veg" ? "border-red-600" : ""} md:*:rounded-md flex items-center justify-center rounded-sm`}
      >
        <div
          className={`lg:w-[10px] lg:h-[10px] w-[6px] h-[6px] rounded-full ${type === "veg" ? "bg-green-600" : ""} ${type === "non_veg" ? "bg-red-600" : ""}`}
        />
      </div>
    </div>
  );
}
